import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useQuery } from "@apollo/client";

import { GET_EVENT_DIVISION } from "../../../../../../graphql/eventDivision";
import { warn } from "../../../../../../actions/notification";
import { useRefocusEffect } from "../../../../../../hooks/useRefocusEffect";
import { useEventChannel } from "../../EventProvider";
import { EventDivisionProvider } from "./EventDivisionProvider";
import { EventDivisionContainer } from "components/layout/eventDivision/EventDivisionContainer";
import { EventDivision } from "../../../../../../models/EventDivision";
import { useBindToChannelEvent } from "../../../../../providers/Realtime/useBindToChannelEvent";

const EventDivisionRoot = ({ children }) => {
    const { eventDivisionId } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();

    const { data, client } = useQuery(GET_EVENT_DIVISION, {
            variables: { id: eventDivisionId },
            fetchPolicy: "cache-and-network",
            nextFetchPolicy: "cache-first"
        }),
        eventDivision = data?.eventDivision;

    const refetch = () => client.query({ query: GET_EVENT_DIVISION, variables: { id: eventDivisionId }, fetchPolicy: "network-only" });

    useRefocusEffect(refetch, true);

    useEffect(() => {
        if (data && !data.eventDivision) {
            dispatch(warn("It looks like we can't find what you are looking for! Perhaps you were looking for one of our organisations?"));
            return history.replace("/organisations");
        }
    }, [data]);

    useBindToChannelEvent(useEventChannel(), "event-division-updated", ({ id: messageId }) => {
        if (eventDivisionId === `${messageId}`) refetch();
    });

    const eventDivisionObject = eventDivision ? EventDivision(eventDivision) : eventDivision;

    return (
        <EventDivisionProvider value={{ eventDivision, eventDivisionObject }}>
            <EventDivisionContainer>
                {children}
            </EventDivisionContainer>
        </EventDivisionProvider>
    );
};
export default EventDivisionRoot;
